import build from '@/__config/build';

// 客戶包不含 board／alliance 時，把程式裡寫死的預設導向轉到設定檔的 homePath；線上包為空陣列。
// redirect 用相對字串，vue-router 會對父路由 /factory/:factoryId 解析，query 與 params 自動沿用。
const routes = [];
if (!build.isModuleEnabled('board')) {
  routes.push({ path: 'board-overview', redirect: build.homePath });
}
if (!build.isModuleEnabled('alliance')) {
  routes.push({ path: 'alliances', redirect: build.homePath });
}

export default routes;
